import type {MonthColumn} from "../../utils";
import {ShimmerBar} from "../skeletonParts.tsx";
import {AccountHeaderCell, MonthHeaderCells} from "./MonthHeaderCells.tsx";
import {COL_SEP_L} from "./tableStyles.ts";

interface PeriodicTableHeaderProps {
    monthColumns: MonthColumn[];
    ytdLabel: string;
    loading?: boolean;
    showPlaceholderColumns?: boolean;
}

export function PeriodicTableHeader({
    monthColumns,
    ytdLabel,
    loading = false,
    showPlaceholderColumns = false,
}: PeriodicTableHeaderProps) {
    return (
        <thead>
            <tr className="bg-gray-50 [&>*]:border-b [&>*]:border-b-gray-200">
                <AccountHeaderCell />
                <MonthHeaderCells
                    columns={monthColumns}
                    showPlaceholders={loading && showPlaceholderColumns}
                    separateFirst={false}
                />
                <th
                    className={`px-3 py-3 text-right text-[12px] font-bold text-gray-900 whitespace-nowrap bg-[#F4FAFE] ${COL_SEP_L}`}
                >
                    {loading && !ytdLabel ? (
                        <ShimmerBar className="ml-auto" style={{width: "3.5rem"}} />
                    ) : (
                        <>YTD t/m {ytdLabel}</>
                    )}
                </th>
                <th
                    className={`px-3 py-3 text-right text-[12px] font-bold text-gray-900 whitespace-nowrap ${COL_SEP_L}`}
                >
                    Totaal
                </th>
            </tr>
        </thead>
    );
}
